import { FieldSet, IDataTableColumn, useGridState, useSearchApi } from "nsitools-react";
import * as React from "react";
import { Link } from "react-router-dom";

import { VeterinaryClinicApi, VeterinaryClinicDto, VeterinaryClinicSearch } from "../../../../../api";
import { CustomDataTable } from "../../../../../components";
import { useGlobalData } from "../../../../../contexts";
import { ERoutes } from "../../../../../ERoutes";
import { useApiService, useTl } from "../../../../../hooks";
import { ETLCodes } from "../../../../../locales";

export interface IVeterinaryClinicsListProps {
  vetId: number;
  editMode: boolean;
}

export const VeterinaryClinicsList: React.FunctionComponent<IVeterinaryClinicsListProps> = ({ vetId, editMode }) => {
  const { t } = useTl();
  const api = useApiService(VeterinaryClinicApi);
  const { currentLanguage } = useGlobalData();

  const tableState = useGridState<any>({
    serverMode: true,
    enablePagination: true,
    enableFilter: true,
    availablePageSizes: [5],
    pageSize: 5,
    sortKeys: { clinicName: "ASC" },
  });

  const searchFunction = React.useCallback(
    (sObj?: VeterinaryClinicSearch) => {
      return api.getClinicFromVeterinary(
        VeterinaryClinicSearch.fromJS({ ...sObj, veterinaryId: +vetId, languageId: currentLanguage.languageId })
      );
    },
    [api, currentLanguage.languageId, vetId]
  );

  const { loading } = useSearchApi<any, any>({
    searchFunction,
    tableState,
    initialSearch: true,
    trimSearchObjectStringValues: true,
  });

  const columns = React.useMemo<IDataTableColumn[]>(
    () => [
      {
        header: () => t(ETLCodes.Name),
        fieldName: "clinicName",
        render: (row: VeterinaryClinicDto) => (
          <Link target="_blank" to={`${ERoutes.clinic}/${row.clinicId}/detail/view`}>
            {row.clinicName}
          </Link>
        ),
      },
    ],
    [t]
  );

  return (
    <>
      <FieldSet title={t(ETLCodes.Clinics)}>
        <CustomDataTable tableState={tableState} loading={loading} columns={columns} />
      </FieldSet>
    </>
  );
};
